import switchFunc from 'lib/function/switchFunc'

export const EXPERIENCE_PRODUCT_TYPE_ALWAYS_ON = 'always_on'
export const EXPERIENCE_PRODUCT_TYPE_FLASH = 'flash'
export const EXPERIENCE_PRODUCT_TYPE_CHANNEL_MANAGER = 'channel_manager'
export const EXPERIENCE_PRODUCT_TYPE_TRANSFER = 'transfer'
export const EXPERIENCE_PRODUCT_TYPES: Array<App.ExperienceProductType> = [EXPERIENCE_PRODUCT_TYPE_ALWAYS_ON, EXPERIENCE_PRODUCT_TYPE_FLASH, EXPERIENCE_PRODUCT_TYPE_CHANNEL_MANAGER]
export const EXPERIENCE_MINIMUM_DISCOUNT_PERCENTAGE_TO_SHOW = 5
export const EXPERIENCE_GIFT_SCHEDULE_DATE_LIMIT_BEFORE_EXPIRATION_DATE = 14
export const EXPERIENCE_ANY_DATE = 'any'
export const EXPERIENCE_TRANSFER_ID = 36
export const EXPERIENCE_CANCELLATION_REASON_DOWNGRADED = 'downgraded'

export const EXPERIENCE_WL_DESTINATIONS: Array<App.Place> = [
  { id: 'le_15fa44474c92da27cf2125373356db4c', name: 'Melbourne' },
  { id: 'le_678c61ac5b4f91ca86e112fc50e63766', name: 'Sydney' },
  { id: 'le_b96d145f6c31e35755f4a6841574ba37', name: 'Brisbane' },
  { id: 'le_bac732346917b0a1231354ef55faf00a', name: 'Gold Coast' },
  { id: 'le_f4c2c73d7fe5eb38fd83d32a61604247', name: 'Adelaide' },
  { id: 'le_7c27cf9f8fe09724bb754e474610eb0e', name: 'Perth' },
  { id: 'le_8f85517967795eeef66c225f7883bdcb', name: 'Thailand' },
  { id: 'le_64930b7151b6bc3e289f37d5da62ac9f', name: 'Bali' },
  { id: 'le_d41d8cd98f00b204e9800998ecf8427e', name: 'Anywhere' },
]
export const EXPERIENCE_LE_DESTINATIONS: Array<App.Place> = [
  { id: 'le_15fa44474c92da27cf2125373356db4c', name: 'Melbourne' },
  { id: 'le_9fc3d7152ba9336a670e36d0ed79bc43', name: 'New Zealand' },
  { id: 'le_72b32a1f754ba1c09b3695e0cb6cde7f', name: 'Fiji' },
  { id: 'le_678c61ac5b4f91ca86e112fc50e63766', name: 'Sydney' },
  { id: 'le_64930b7151b6bc3e289f37d5da62ac9f', name: 'Bali' },
  { id: 'le_8f85517967795eeef66c225f7883bdcb', name: 'Thailand' },
  { id: 'le_bac732346917b0a1231354ef55faf00a', name: 'Gold Coast' },
  { id: 'le_d41d8cd98f00b204e9800998ecf8427e', name: 'Anywhere' },
]

export const destinationsMap = switchFunc<Array<App.Place>, App.BrandName>({
  luxuryescapes: EXPERIENCE_LE_DESTINATIONS,
  treatmetravel: [
    { id: 'le_464adf7b911508701f4c4e70eab19a6e', name: 'Auckland' },
    { id: 'le_1e15efc3fac4ba31daa6f91082c97e97', name: 'Christchurch' },
    { id: 'le_5a4773830c5a9191a6bd6c301d060ad2', name: 'Queenstown' },
    { id: 'le_9fc3d7152ba9336a670e36d0ed79bc43', name: 'New Zealand' },
    { id: 'le_678c61ac5b4f91ca86e112fc50e63766', name: 'Sydney' },
    { id: 'le_15fa44474c92da27cf2125373356db4c', name: 'Melbourne' },
    { id: 'le_b96d145f6c31e35755f4a6841574ba37', name: 'Brisbane' },
    { id: 'le_d41d8cd98f00b204e9800998ecf8427e', name: 'Anywhere' },
  ],
},
EXPERIENCE_WL_DESTINATIONS)

export const EXPERIENCE_SEARCH_TYPES: Array<App.SearchType> = ['destination', 'experience']

export const EXPERIENCE_TYPEAHEAD_SEARCH_TYPES: Array<App.SearchPlaceType> = [
  'province_state',
  'neighborhood',
  'city',
  'multi_city_vicinity',
  'high_level_region',
  'country',
  'continent',
  'colloquial_area',
  'le_experience',
  'channel_experience',
]

export const AnythingCategory: App.ExperienceItemCategory = {
  id: 999,
  imageId: '',
  level: 'parent',
  name: 'Anything',
}

export enum ExperienceBookingType {
  BUY_NOW_BOOK_LATER = 'buy_now_book_later',
  INSTANT_BOOKING = 'instant_booking',
}

export const EXP_CATEGORY_AIRPORT_TRANSFER_ID = 36
export const EXP_CATEGORY_AIRPORT_LOUNGE_ID = 46
export const EXP_CATEGORY_WATER_TRANSFER_ID = 55
export const EXP_CATEGORY_PRIVATE_TRANSFER_ID = 37
export const EXP_CATEGORY_PHOTOSHOOT_TRAVELSHOOT_ID = 43
export const EXP_CATEGORY_LUX_PLUS_ID = 66
export const EXP_CATEGORY_LUX_PLUS_MEMBER_PRICES_ID = 67
export const EXP_CATEGORY_GIFT_INSPIRATION = 56

export const EXPERIENCE_IN_FLOW_MAX_SHOWN = 12

export const EmptyExperienceList: NonNullable<App.ExperienceListState['']> = {
  ids: [],
  total: 0,
  fetching: true,
}

export const PROVIDERS: Record<string, string> = {
  led: 'led',
  rez: 'rezdy',
  dby: 'derbysoft',
  klo: 'klook',
  asp: 'aspire',
  cln: 'collinson',
  cmc: 'customlinc',
}

// Disney California Adventure offer IDs (all include both Disneyland and Disney California Adventure parks)
export const DISNEY_CALIFORNIA_OFFER_IDS = [
  'dby:disneyland',
  'dby:disneyland-aunz-exclusive',
  'dby:176e6b74-1611-42a8-80f7-964d8f3ed857',
  'dby:05e08d61-7750-47a7-958d-13d9a27f2f3b',
  'dby:disneyland-hopper', // deprecated but may still exist in data
] as const

// Disney Orlando (Walt Disney World) offer ID
export const DISNEY_ORLANDO_OFFER_ID = 'dby:walt-disney-world' as const

export const EXPERIENCES_SEARCH_COMPACT_TILES_AB_TEST_AI_TITLES: Record<string, string> = {
  // Sydney
  'led:006RF00000L803bYAB': '2.5-Hour Pub Crawl in The Rocks',
  'led:006RF00000HCxH7YAL': 'Sydney Airport Lounge Access',
  'led:006RF00000KwQTFYA3': 'Harbourfront 3-Course Meal for Two',
  'led:0062y00000F0FcWAAV': '10-Course Indian Banquet at Manjit’s',
  'led:006RF00000JDfiLYAT': 'Japanese Teppanyaki Banquet in The Rocks',
  'led:006RF00000KwR5yYAF': '4-Course Greek Feast for Two',
  'led:0062y00000IbIDrAAN': '30-Min Shark Attack Jet Boat Ride',
  'led:006RF00000H6u5pYAB': '9-Dish Asian Banquet for Two',
  'led:006RF00000Knk9RYAR': '12-Course Degustation at Quoi',
  'led:006RF00000KUv71YAD': '6-Course Winter Chalet Dining for Two',
  'led:0062y00000FcBCjAAN': 'Spa Day with High Tea for Two',
  'led:006RF00000I4nEHYAZ': 'Afternoon Tea at Hilton Sydney',
  'led:0062y00000IcqdaAAB': 'Massage or Facial with High Tea',
  'led:006RF00000EE0mTYAT': '8-Course French-Japanese Degustation',
  'led:006RF00000L2qMcYAJ': 'Seafood Buffet Brunch at Sheraton',
  'led:0062y00000Gv1P7AAJ': 'Gin Distillery Tour with Tasting',
  'led:006RF00000HpDW7YAN': '2-Hour Sydney Harbour Kayak Tour',
  'led:006RF00000JJvxJYAT': 'Hunter Valley Food & Wine Tour',
  'led:006RF00000IRTQBYA5': 'Italian Tasting Menu for Two',
  'led:006RF00000EE005YAD': '5-Course Tasting Menu at Luke’s',
  'led:006RF00000KQwG9YAL': '2-Hour Cocktails with Grazing Board',
  'led:006RF00000Dg1EsYAJ': '5-Course Dining at Cottage Point',
  'led:0062y00000DpkDnAAJ': 'Waterfront High Tea at Ripples',
  'rez:PYVWTZ': '1.5-Hour Sunset Harbour Cruise',
  'led:006RF00000DkeHVYAZ': 'High Tea at Akuna Bay for Two',
  'led:006RF00000Ikb3qYAB': '3-Course Steakhouse Meal for Two',
  'led:006RF00000IlZ3BYAV': 'Featherdale Wildlife Park Ticket',
  'led:006RF00000IkyLNYAZ': 'Market Menu Dining at Sydney Common',
  'led:006RF00000EE0RVYA1': 'Rooftop Rose & Dips Platter for Two',
  'led:006RF00000KtCMqYAN': 'Sunrise Balloon Flight with Breakfast',

  // Brisbane
  'led:0062y00000Dp1FIAAZ': '80-Min Facial or 2-Hour Spa in Bulimba',
  'led:006Ii000002JJwsIAG': 'Brisbane Airport Lounge Access',
  'led:006RF00000EH7OPYA1': '70-Min Massage & Foot Soak in Brisbane',
  'led:0062y00000IbnUtAAJ': '2-Hour Goodna Cemetery Ghost Tour',
  'led:0062y00000Dp1OmAAJ': '2-Hour Spa Package with Wine in Brisbane',
  'rez:PP2YUG': '2-Hour Moreton Bay Sunset Cruise',
  'led:006Ii000002I9GwIAK': 'Italian Dinner for Two in Brisbane CBD',
  'led:006RF00000EDYbhYAH': 'A$100 Dining Credit at Eagles Nest Bar',
  'led:006RF00000EDVVmYAP': '4 Cocktails & Cheese Platter for Two',
  'led:0062y00000DNtKLAA1': 'Cielo Rooftop Cocktails & Cheese for Two',
  'rez:PXNR9P': 'White Ridge Farm Entry with Mini-Golf',
  'rez:PX60YU': 'Daytime Story Bridge Climb with Photo',
  'led:006RF00000C0YafYAF': '3-Course Italian Meal for Two in West End',
  'rez:PQEYVT': 'Full-Day Stradbroke Island Sunset Tour',
  'led:006RF00000H48q1YAB': 'Seafood Feast & Wine Tasting for Two',
  'rez:PTMB07': 'Hop-On Hop-Off Tamborine Brewery Tour',
  'led:0062y00000IbnVPAAZ': '2-Hour Toowong Cemetery Ghost Tour',
  'led:006RF00000EDYwfYAH': '2 or 3-Course Dinner at Lamberts for Two',
  'rez:P65QSD': 'Moreton Bay Snorkel Cruise with Lunch',
  'led:0062y00000JRdhvAAD': '2-Hour Pottery Wheel Class for Beginners',
  'led:006RF00000C0UVSYA3': '3-Course Italian Dining in Newstead',
  'led:0062y00000IbnVKAAZ': '2-Hour Toowong Cemetery Ghost Walk',
  'rez:PQQFW2': 'Full-Day Tamborine Winery Tour with Lunch',
  'led:0062y00000C25iWAAR': 'Sirromet Winery Tour with Lunch & Wine',
  'rez:PMGXGV': '90-Min Fortitude Valley True Crime Tour',
  'led:006RF00000GCLDyYAP': 'Half-Day Yacht Charter with Afternoon Tea',
  'led:0062y00000IbnVGAAZ': '2-Hour Haunted Ipswich CBD Ghost Tour',
  'led:0062y00000IbnV1AAJ': '2-Hour Ipswich Cemetery Ghost Tour',
  'led:0062y00000IbnUrAAJ': '2-Hour Brisbane CBD Ghost Walking Tour',
  'led:0062y00000DpTk8AAF': '2-Hour Spa Package in Clear Mountain',
}

/**
 * Maps carousel analytics names (from BigQuery / admin portal) to the heading
 * text rendered on the Experiences landing page. Used by the ?carousel= query
 * param to scroll to the matching carousel section.
 *
 * Values must match the defaultMessage of each carousel's heading (intl).
 */
export const CAROUSEL_HEADING_TEXT: Record<string, string> = {
  'OfferList - EXPERIENCES - Recently Viewed Carousel': 'Recently viewed',
  'OfferList - EXPERIENCES - Experiences Top Three Carousel': 'Our top 3 experiences',
  'OfferList - EXPERIENCES - YAML Carousel': 'Local discounts exclusive to LuxPlus+ members',
  'OfferList - EXPERIENCES - Experiences Our exclusive experiences Carousel': 'Our exclusive experiences',
  'OfferList - EXPERIENCES - Experiences Top activities for you Carousel': 'Top activities for you',
  'OfferList - EXPERIENCES - Experiences Discover dining experiences Carousel': 'Discover dining experiences',
  'OfferList - EXPERIENCES - Experiences Explore your destination Carousel': 'Explore your destination',
  'OfferList - EXPERIENCES - Collections Carousel - Summer Highlights': 'Summer Highlights',
  'OfferList - EXPERIENCES - Collections Carousel - Things to Do with Kids': 'Things to Do with Kids',
  'OfferList - EXPERIENCES - Collections Carousel - Romantic Experiences': 'Romantic Experiences',
  'OfferList - EXPERIENCES - Collections Carousel - Perfect Gifts for Someone Special': 'Perfect Gifts for Someone Special',
  'OfferList - EXPERIENCES - Experiences See the sights Carousel': 'See the sights',
  'OfferList - EXPERIENCES - Experiences Live events Carousel': 'Live events',
  'OfferList - EXPERIENCES - Experiences Indulge yourself Carousel': 'Indulge yourself',
}

export type TransferType = 'AIRPORT-TO-HOTEL' | 'HOTEL-TO-AIRPORT' | 'ROUND-TRIP'
export type TransferTripTypeDisplayText = 'Round trip' | 'Airport to Hotel' | 'Hotel to Airport'

export interface BaliHotelLocation {
  name: string
  area: string
  zone: number
  placeId: string
}

export interface BaliHotelLocationsResponse {
  hotels: Array<BaliHotelLocation>
}
